import React from "react";
import { createRoot } from "react-dom/client";

import "@coreui/coreui/dist/css/coreui.min.css";

import App from "../App";
import LoginPage from "../pages/LoginPage";
import SignupPage from "../pages/SignupPage";

const el = document.getElementById("react-root");

if (el) {
    const page = el.dataset.page;

    const pages = {
        login: <LoginPage />,
        signup: <SignupPage />,
        app: <App />,
    };

    createRoot(el).render(pages[page] || <App />);
}
